import React from "react";
import "./howWeWork.scss";
import { Users, Document, Calendar, Key, Home } from "../../../icons";

const HowWeWork: React.FC = () => {
  const steps = [
    {
      number: "01",
      image: "/images/process-01.jpg",
      title: (
        <>
          ROZMOWA
          <br />I ANALIZA POTRZEB
        </>
      ),
      text: (
        <>
          Poznajemy Twoje potrzeby,
          <br />
          oczekiwania i możliwości.
          <br />
          Doradzamy najlepsze
          <br />
          rozwiązania.
        </>
      ),
      Icon: Users,
    },
    {
      number: "02",
      image: "/images/process-02.jpg",
      title: (
        <>
          WYCENA
          <br />I ZAKRES PRAC
        </>
      ),
      text: (
        <>
          Przygotowujemy przejrzystą
          <br />
          wycenę oraz szczegółowy
          <br />
          zakres prac dopasowany
          <br />
          do Twojej inwestycji.
        </>
      ),
      Icon: Document,
    },
    {
      number: "03",
      image: "/images/process-03.jpg",
      title: (
        <>
          PLANOWANIE
          <br />I PRZYGOTOWANIE
        </>
      ),
      text: (
        <>
          Ustalamy harmonogram,
          <br />
          zamawiamy materiały
          <br />
          i organizujemy wszystkie
          <br />
          niezbędne zasoby.
        </>
      ),
      Icon: Calendar,
    },
    {
      number: "04",
      image: "/images/process-04.jpg",
      title: (
        <>
          REALIZACJA
          <br />
          INWESTYCJI
        </>
      ),
      text: (
        <>
          Nasza ekipa realizuje prace
          <br />
          zgodnie z planem, dbając
          <br />
          o jakość, bezpieczeństwo
          <br />i porządek na budowie.
        </>
      ),
      Icon: Home,
    },
    {
      number: "05",
      image: "/images/process-05.jpg",
      title: (
        <>
          ODDANIE
          <br />I WSPARCIE
        </>
      ),
      text: (
        <>
          Przekazujemy gotową
          <br />
          inwestycję i pozostajemy
          <br />
          do Twojej dyspozycji
          <br />
          również po zakończeniu prac.
        </>
      ),
      Icon: Key,
    },
  ];

  return (
    <section className="process">
      <div className="process__container">
        <header className="process__header">
          <div className="process__header-top">
            <span className="process__header-line" />
            <span className="process__eyebrow">JAK DZIAŁAMY</span>
            <span className="process__header-line" />
          </div>

          <h2 className="process__heading">
            Prosty proces. Jasne zasady.
            <br />
            Świetne efekty.
          </h2>

          <p className="process__description">
            Działamy etapami, dzięki czemu masz pełną kontrolę nad inwestycją
            <br className="process__desktop-break" />i wiesz, na jakim etapie
            realizacji się znajdujemy.
          </p>
        </header>

        <div className="process__steps">
          {steps.map((step) => {
            const Icon = step.Icon;
            return (
              <article className="process__step" key={step.number}>
                <div className="process__wrapper">
                  <span className="process__number">{step.number}</span>
                </div>

                <div className="process__timeline">
                  <span className="process__timeline-dot" />
                </div>

                <div className="process__content">
                  <div className="process__icon">
                    <Icon />
                  </div>

                  <h3 className="process__title">{step.title}</h3>

                  <p className="process__text">{step.text}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
